import { ToolbarControlOptionsMap, CANVAS_REMOVE_FORMAT } from 'tinymce-plugins/constants/toolbar';
export const includesToolbarControl = (toolbarControls, control) => {
  // Automatically include the control if no [toolbarControls] array is present
  if (!Array.isArray(toolbarControls) || !toolbarControls.length) {
    return true;
  }
  return toolbarControls.includes(control);
};

// Given the [enabledFeatures] array passed down from the [getConfig] callee,
// generate the appropriate [toolbarControls] array
export const getToolbarControls = (enabledFeatures = []) => {
  if (!Array.isArray(enabledFeatures) || !enabledFeatures.length) {
    return null;
  }
  const toolbarControls = enabledFeatures.reduce((acc, option) => {
    if (Object.prototype.hasOwnProperty.call(ToolbarControlOptionsMap, option)) {
      acc.push(...ToolbarControlOptionsMap[option]);
    }
    return acc;
  }, []);
  if (!toolbarControls.length) {
    return null;
  }

  // Always add remove format control
  toolbarControls.push(CANVAS_REMOVE_FORMAT);
  return toolbarControls;
};